(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["antiiva-basic-offer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    const button = event.target.closest('[data-quantity-minus], [data-quantity-plus]');
    if (!button) return;
    const wrapper = button.closest('.antiiva-offer__quantity');
    const input = wrapper && wrapper.querySelector('input[name="quantity"]');
    if (!input) return;
    const current = Number.parseInt(input.value, 10) || 1;
    input.value = button.hasAttribute('data-quantity-plus') ? current + 1 : Math.max(1, current - 1);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["antiiva-master-page"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    const offerImage = event.target.closest('[data-master-offer-image]');
    if (offerImage) {
      const cardButton = offerImage.closest('[data-master-offer-card]').querySelector('[data-master-offer]');
      if (cardButton) cardButton.click();
      return;
    }

    const offerButton = event.target.closest('[data-master-offer]');
    if (offerButton) {
      const section = offerButton.closest('.antiiva-master');
      const form = section && section.querySelector('.antiiva-master__form');
      const variantField = form && form.querySelector('[name="id"]');
      if (!section || !form || !variantField) return;

      variantField.value = offerButton.dataset.variantId;
      variantField.dispatchEvent(new Event('change', { bubbles: true }));
      const price = section.querySelector('.antiiva-master__price');
      if (price) price.textContent = offerButton.dataset.price;

      section.querySelectorAll('[data-master-offer-card]').forEach(function(card) {
        card.classList.remove('antiiva-master__offer--selected');
      });
      section.querySelectorAll('[data-master-offer]').forEach(function(button) {
        button.classList.remove('is-current');
        const label = button.querySelector('[data-master-offer-label]');
        if (label) label.textContent = button.dataset.selectText;
      });
      const selectedCard = offerButton.closest('[data-master-offer-card]');
      selectedCard.classList.add('antiiva-master__offer--selected');
      const currentBadge = section.querySelector('[data-master-current-badge]');
      if (currentBadge) selectedCard.prepend(currentBadge);
      offerButton.classList.add('is-current');
      const selectedLabel = offerButton.querySelector('[data-master-offer-label]');
      if (selectedLabel) selectedLabel.textContent = '✓ ' + offerButton.dataset.currentText;

      const addButton = form.querySelector('[name="add"]');
      if (addButton) addButton.disabled = offerButton.dataset.available !== 'true';
      return;
    }

    const button = event.target.closest('[data-master-minus], [data-master-plus]');
    if (!button) return;
    const wrapper = button.closest('.antiiva-master__quantity');
    const input = wrapper && wrapper.querySelector('input[name="quantity"]');
    if (!input) return;
    const quantity = Number.parseInt(input.value, 10) || 1;
    input.value = button.hasAttribute('data-master-plus') ? quantity + 1 : Math.max(1, quantity - 1);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gluco800-page"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    const offerImage = event.target.closest('[data-master-offer-image]');
    if (offerImage) {
      const cardButton = offerImage.closest('[data-master-offer-card]').querySelector('[data-master-offer]');
      if (cardButton) cardButton.click();
      return;
    }

    const offerButton = event.target.closest('[data-master-offer]');
    if (offerButton) {
      const section = offerButton.closest('.antiiva-master');
      const form = section && section.querySelector('.antiiva-master__form');
      const variantField = form && form.querySelector('[name="id"]');
      if (!section || !form || !variantField) return;

      variantField.value = offerButton.dataset.variantId;
      variantField.dispatchEvent(new Event('change', { bubbles: true }));
      const price = section.querySelector('.antiiva-master__price');
      if (price) price.textContent = offerButton.dataset.price;

      section.querySelectorAll('[data-master-offer-card]').forEach(function(card) {
        card.classList.remove('antiiva-master__offer--selected');
      });
      section.querySelectorAll('[data-master-offer]').forEach(function(button) {
        button.classList.remove('is-current');
        const label = button.querySelector('[data-master-offer-label]');
        if (label) label.textContent = button.dataset.selectText;
      });
      const selectedCard = offerButton.closest('[data-master-offer-card]');
      selectedCard.classList.add('antiiva-master__offer--selected');
      const currentBadge = section.querySelector('[data-master-current-badge]');
      if (currentBadge) selectedCard.prepend(currentBadge);
      offerButton.classList.add('is-current');
      const selectedLabel = offerButton.querySelector('[data-master-offer-label]');
      if (selectedLabel) selectedLabel.textContent = '✓ ' + offerButton.dataset.currentText;

      const addButton = form.querySelector('[name="add"]');
      if (addButton) addButton.disabled = offerButton.dataset.available !== 'true';
      return;
    }

    const button = event.target.closest('[data-master-minus], [data-master-plus]');
    if (!button) return;
    const wrapper = button.closest('.antiiva-master__quantity');
    const input = wrapper && wrapper.querySelector('input[name="quantity"]');
    if (!input) return;
    const quantity = Number.parseInt(input.value, 10) || 1;
    input.value = button.hasAttribute('data-master-plus') ? quantity + 1 : Math.max(1, quantity - 1);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mens-health-pack-page"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    const offerImage = event.target.closest('[data-master-offer-image]');
    if (offerImage) {
      const cardButton = offerImage.closest('[data-master-offer-card]').querySelector('[data-master-offer]');
      if (cardButton) cardButton.click();
      return;
    }

    const offerButton = event.target.closest('[data-master-offer]');
    if (offerButton) {
      const section = offerButton.closest('.antiiva-master');
      const form = section && section.querySelector('.antiiva-master__form');
      const variantField = form && form.querySelector('[name="id"]');
      if (!section || !form || !variantField) return;

      variantField.value = offerButton.dataset.variantId;
      variantField.dispatchEvent(new Event('change', { bubbles: true }));
      const price = section.querySelector('.antiiva-master__price');
      if (price) price.textContent = offerButton.dataset.price;

      section.querySelectorAll('[data-master-offer-card]').forEach(function(card) {
        card.classList.remove('antiiva-master__offer--selected');
      });
      section.querySelectorAll('[data-master-offer]').forEach(function(button) {
        button.classList.remove('is-current');
        const label = button.querySelector('[data-master-offer-label]');
        if (label) label.textContent = button.dataset.selectText;
      });
      const selectedCard = offerButton.closest('[data-master-offer-card]');
      selectedCard.classList.add('antiiva-master__offer--selected');
      const currentBadge = section.querySelector('[data-master-current-badge]');
      if (currentBadge) selectedCard.prepend(currentBadge);
      offerButton.classList.add('is-current');
      const selectedLabel = offerButton.querySelector('[data-master-offer-label]');
      if (selectedLabel) selectedLabel.textContent = '✓ ' + offerButton.dataset.currentText;

      const addButton = form.querySelector('[name="add"]');
      if (addButton) addButton.disabled = offerButton.dataset.available !== 'true';
      return;
    }

    const button = event.target.closest('[data-master-minus], [data-master-plus]');
    if (!button) return;
    const wrapper = button.closest('.antiiva-master__quantity');
    const input = wrapper && wrapper.querySelector('input[name="quantity"]');
    if (!input) return;
    const quantity = Number.parseInt(input.value, 10) || 1;
    input.value = button.hasAttribute('data-master-plus') ? quantity + 1 : Math.max(1, quantity - 1);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["milk-thistle-page"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    const offerImage = event.target.closest('[data-master-offer-image]');
    if (offerImage) {
      const cardButton = offerImage.closest('[data-master-offer-card]').querySelector('[data-master-offer]');
      if (cardButton) cardButton.click();
      return;
    }

    const offerButton = event.target.closest('[data-master-offer]');
    if (offerButton) {
      const section = offerButton.closest('.antiiva-master');
      const form = section && section.querySelector('.antiiva-master__form');
      const variantField = form && form.querySelector('[name="id"]');
      if (!section || !form || !variantField) return;

      variantField.value = offerButton.dataset.variantId;
      variantField.dispatchEvent(new Event('change', { bubbles: true }));
      const price = section.querySelector('.antiiva-master__price');
      if (price) price.textContent = offerButton.dataset.price;

      section.querySelectorAll('[data-master-offer-card]').forEach(function(card) {
        card.classList.remove('antiiva-master__offer--selected');
      });
      section.querySelectorAll('[data-master-offer]').forEach(function(button) {
        button.classList.remove('is-current');
        const label = button.querySelector('[data-master-offer-label]');
        if (label) label.textContent = button.dataset.selectText;
      });
      const selectedCard = offerButton.closest('[data-master-offer-card]');
      selectedCard.classList.add('antiiva-master__offer--selected');
      const currentBadge = section.querySelector('[data-master-current-badge]');
      if (currentBadge) selectedCard.prepend(currentBadge);
      offerButton.classList.add('is-current');
      const selectedLabel = offerButton.querySelector('[data-master-offer-label]');
      if (selectedLabel) selectedLabel.textContent = '✓ ' + offerButton.dataset.currentText;

      const addButton = form.querySelector('[name="add"]');
      if (addButton) addButton.disabled = offerButton.dataset.available !== 'true';
      return;
    }

    const button = event.target.closest('[data-master-minus], [data-master-plus]');
    if (!button) return;
    const wrapper = button.closest('.antiiva-master__quantity');
    const input = wrapper && wrapper.querySelector('input[name="quantity"]');
    if (!input) return;
    const quantity = Number.parseInt(input.value, 10) || 1;
    input.value = button.hasAttribute('data-master-plus') ? quantity + 1 : Math.max(1, quantity - 1);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ultra-nerve-support-page"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    const offerImage = event.target.closest('[data-master-offer-image]');
    if (offerImage) {
      const cardButton = offerImage.closest('[data-master-offer-card]').querySelector('[data-master-offer]');
      if (cardButton) cardButton.click();
      return;
    }

    const offerButton = event.target.closest('[data-master-offer]');
    if (offerButton) {
      const section = offerButton.closest('.antiiva-master');
      const form = section && section.querySelector('.antiiva-master__form');
      const variantField = form && form.querySelector('[name="id"]');
      if (!section || !form || !variantField) return;

      variantField.value = offerButton.dataset.variantId;
      variantField.dispatchEvent(new Event('change', { bubbles: true }));
      const price = section.querySelector('.antiiva-master__price');
      if (price) price.textContent = offerButton.dataset.price;

      section.querySelectorAll('[data-master-offer-card]').forEach(function(card) {
        card.classList.remove('antiiva-master__offer--selected');
      });
      section.querySelectorAll('[data-master-offer]').forEach(function(button) {
        button.classList.remove('is-current');
        const label = button.querySelector('[data-master-offer-label]');
        if (label) label.textContent = button.dataset.selectText;
      });
      const selectedCard = offerButton.closest('[data-master-offer-card]');
      selectedCard.classList.add('antiiva-master__offer--selected');
      const currentBadge = section.querySelector('[data-master-current-badge]');
      if (currentBadge) selectedCard.prepend(currentBadge);
      offerButton.classList.add('is-current');
      const selectedLabel = offerButton.querySelector('[data-master-offer-label]');
      if (selectedLabel) selectedLabel.textContent = '✓ ' + offerButton.dataset.currentText;

      const addButton = form.querySelector('[name="add"]');
      if (addButton) addButton.disabled = offerButton.dataset.available !== 'true';
      return;
    }

    const button = event.target.closest('[data-master-minus], [data-master-plus]');
    if (!button) return;
    const wrapper = button.closest('.antiiva-master__quantity');
    const input = wrapper && wrapper.querySelector('input[name="quantity"]');
    if (!input) return;
    const quantity = Number.parseInt(input.value, 10) || 1;
    input.value = button.hasAttribute('data-master-plus') ? quantity + 1 : Math.max(1, quantity - 1);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vitamin-d3-page"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    const offerImage = event.target.closest('[data-master-offer-image]');
    if (offerImage) {
      const cardButton = offerImage.closest('[data-master-offer-card]').querySelector('[data-master-offer]');
      if (cardButton) cardButton.click();
      return;
    }

    const offerButton = event.target.closest('[data-master-offer]');
    if (offerButton) {
      const section = offerButton.closest('.antiiva-master');
      const form = section && section.querySelector('.antiiva-master__form');
      const variantField = form && form.querySelector('[name="id"]');
      if (!section || !form || !variantField) return;

      variantField.value = offerButton.dataset.variantId;
      variantField.dispatchEvent(new Event('change', { bubbles: true }));
      const price = section.querySelector('.antiiva-master__price');
      if (price) price.textContent = offerButton.dataset.price;

      section.querySelectorAll('[data-master-offer-card]').forEach(function(card) {
        card.classList.remove('antiiva-master__offer--selected');
      });
      section.querySelectorAll('[data-master-offer]').forEach(function(button) {
        button.classList.remove('is-current');
        const label = button.querySelector('[data-master-offer-label]');
        if (label) label.textContent = button.dataset.selectText;
      });
      const selectedCard = offerButton.closest('[data-master-offer-card]');
      selectedCard.classList.add('antiiva-master__offer--selected');
      const currentBadge = section.querySelector('[data-master-current-badge]');
      if (currentBadge) selectedCard.prepend(currentBadge);
      offerButton.classList.add('is-current');
      const selectedLabel = offerButton.querySelector('[data-master-offer-label]');
      if (selectedLabel) selectedLabel.textContent = '✓ ' + offerButton.dataset.currentText;

      const addButton = form.querySelector('[name="add"]');
      if (addButton) addButton.disabled = offerButton.dataset.available !== 'true';
      return;
    }

    const button = event.target.closest('[data-master-minus], [data-master-plus]');
    if (!button) return;
    const wrapper = button.closest('.antiiva-master__quantity');
    const input = wrapper && wrapper.querySelector('input[name="quantity"]');
    if (!input) return;
    const quantity = Number.parseInt(input.value, 10) || 1;
    input.value = button.hasAttribute('data-master-plus') ? quantity + 1 : Math.max(1, quantity - 1);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  } catch(e) { console.error(e); }
})();
})();
